// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"ChoroplethDataTable_dataContainer__3WdK4","optionContainer":"ChoroplethDataTable_optionContainer__39AeG","input":"ChoroplethDataTable_input__3nJAQ"};